import WizardStepNav from '../wizard/WizardStepNav'
import type { CT600WizardStepId, CT600WizardStep } from '../../types/ct600Filing'

interface Props {
  steps: CT600WizardStep[]
  currentStep: CT600WizardStepId
  completedSteps: Set<CT600WizardStepId>
  onStepClick: (step: CT600WizardStepId) => void
  variant?: 'mobile' | 'desktop' | 'both' | 'tabs'
}

/** CT600-typed adapter over the shared {@link WizardStepNav}. */
export default function CT600StepNav({ steps, currentStep, completedSteps, onStepClick, variant = 'both' }: Props) {
  return (
    <WizardStepNav
      steps={steps}
      currentStep={currentStep}
      completedSteps={completedSteps as Set<number>}
      onStepClick={(step) => onStepClick(step as CT600WizardStepId)}
      variant={variant}
    />
  )
}
